import { render, staticRenderFns } from "./Refrigerant.vue?vue&type=template&id=5bf315ee&"
import script from "./Refrigerant.vue?vue&type=script&lang=js&"
export * from "./Refrigerant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports